const textFields = new Set(['tab_id', 'incident_id', 'connection_id', 'server_connection_id',
    'server_instance_id', 'server_release', 'client_release', 'occurred_at', 'cause', 'confidence',
    'visibility', 'protocol', 'initiator', 'sync_result', 'consumer'])
const numberFields = new Set(['incoming_age_ms', 'ack_age_ms', 'rtt_ms', 'timer_lag_ms', 'attempts',
    'duration_ms', 'close_code', 'dropped_records', 'sequence'])
export const websocketLogCodes = new Set(['ws_interrupted', 'ws_retry_summary', 'ws_recovered', 'ws_lifecycle', 'ws_resync'])

export function websocketLogContext(value) {
    if (!value || value.diagnostic_version !== 1) return undefined
    const result = { diagnostic_version: 1 }
    for (const [key, item] of Object.entries(value)) {
        if (textFields.has(key) && typeof item === 'string' && /^[a-zA-Z0-9_.:/ +-]*$/.test(item)) result[key] = item.slice(0, 128)
        if (numberFields.has(key) && Number.isFinite(item) && item >= 0 && item <= 1e12) result[key] = item
        if (['browser_online', 'was_clean'].includes(key) && typeof item === 'boolean') result[key] = item
    }
    return result.cause && result.confidence ? result : undefined
}
